import { Info } from "@mui/icons-material";
import { Badge, Box, Paper, Stack, Typography } from "@mui/material";

function CustomCard({
  label,
  headerRight,
  subtitle,
  children,
}: {
  label: string;
  headerRight?: string;
  subtitle?: string;
  children: React.ReactNode;
}) {
  return (
    <Paper
      elevation={4}
      sx={{
        p: 3,
        display: "flex",
        flexDirection: "column",
        borderRadius: 2.5,
        height: "100%",
      }}
    >
      {/* Header Section */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1.5,
          mb: 3,
        }}
      >
        <Stack direction="row" alignItems="flex-start" spacing={1}>
          <Info sx={{ fontSize: 18, mt: 0.2 }} />

          <Stack direction="column" alignItems="flex-start" spacing={0.25}>
            <Typography
              variant="body2"
              sx={{
                color: "text.primary",
                fontWeight: 700,
                fontSize: "0.9rem",
                textTransform: "uppercase",
                letterSpacing: 0.5,
              }}
            >
              {label}
            </Typography>

            {subtitle && (
              <Typography variant="caption" color="text.secondary">
                {subtitle}
              </Typography>
            )}
          </Stack>
        </Stack>

        {headerRight && (
          <Badge
            badgeContent={headerRight}
            color="secondary"
            sx={{
              "& .MuiBadge-badge": {
                fontSize: 12,
                fontWeight: 600,
                minWidth: 24,
                height: 20,
                px: 1,
                py: 0.25,
              },
            }}
          >
            <Box sx={{ width: 12, height: 12 }} />
          </Badge>
        )}
      </Box>

      {/* Content */}
      <Box sx={{ flex: 1 }}>{children}</Box>
    </Paper>
  );
}

export default CustomCard;
